import { lazy } from "react";

const CajaLayout = lazy(() => import("../../caja/CajaLayout.jsx"));
const Cajas = lazy(() => import("../../caja/Cajas.jsx"));

const CajaApertura = lazy(() => import("../../caja/AperturaCaja.jsx"));
const CajaCierre = lazy(() => import("../../caja/CierreCaja.jsx"));
const ReporteMovimientos = lazy(() => import("../../caja/ReporteMovimientos.jsx"));
const SinCajaAbierta = lazy(() => import("../../caja/SinCajaAbierta.jsx"));

// caja manager
const CajaManagerLayout = lazy(() => import("../../empresa/cajas/CajaManagerLayout.jsx"));
const CajaManager = lazy(() => import("../../empresa/cajas/CajaManager.jsx"));
const CajaForm = lazy(() => import("../../empresa/cajas/CajaForm.jsx"));

// ingresos-egresos
const IngresoEgresoLayout = lazy(() =>
      import("../../caja/ingreso-egreso/IngresoEgresoLayout.jsx")
);
const IngresosEgresosList = lazy(() =>
      import("../../caja/ingreso-egreso/IngresoEgresoList.jsx")
);
const IngresoEgresoForm = lazy(() =>
      import("../../caja/ingreso-egreso/IngresoEgresoForm.jsx")
);

// devoluciones
const DevolucionesLayout = lazy(() =>
      import("../../caja/devoluciones/DevolucionesLayout.jsx")
);
const DevolucionesList = lazy(() =>
      import("../../caja/devoluciones/DevolucionesList.jsx")
);
const DevolucionForm = lazy(() =>
      import("../../caja/devoluciones/DevolucionForm.jsx")
);

const cajaRoutes = [
      {
            path: "cajas",
            element: <CajaLayout />,
            children: [
                  { index: true, element: <Cajas /> },
                  { path: "apertura/:token", element: <CajaApertura /> },
                  { path: "cierre/:token", element: <CajaCierre /> },
                  { path: "nueva", element: <CajaForm /> },
                  { path: "editar/:token", element: <CajaForm /> },
                  { path: "movimientos", element: <ReporteMovimientos /> },
                  {
                        path: "settings", element: <CajaManagerLayout />,
                        children: [
                              { index: true, element: <CajaManager /> },
                              { path: "nueva", element: <CajaForm /> },
                              { path: "editar/:token", element: <CajaForm /> },
                        ]
                  },



                  {
                        path: "ingresos-egresos",
                        element: (
                              <SinCajaAbierta>
                                    <IngresoEgresoLayout />
                              </SinCajaAbierta>
                        ),
                        children: [
                              { index: true, element: <IngresosEgresosList /> },
                              { path: "nuevo", element: <IngresoEgresoForm /> },
                        ],
                  },

                  {
                        path: "devoluciones",
                        element: (
                              <SinCajaAbierta>
                                    <DevolucionesLayout />
                              </SinCajaAbierta>
                        ),
                        children: [
                              { index: true, element: <DevolucionesList /> },
                              { path: "nueva", element: <DevolucionForm /> },
                        ],
                  },
            ],
      },
];

export default cajaRoutes;